import { ADMIN_EMAIL, COMPANY_NAME, type ParticipantNote } from '@piccolohealth/pbs-common';
import { ChakraV3, FancyDate, ScrollArea } from '@piccolohealth/ui';
import React from 'react';
import { showModal } from '../../components/generic/Modal';
import { UserDescription } from '../../components/user/UserDescription';
import { ManageParticipantNoteLabelsControl } from './ManageParticipantNoteLabelsControl';
import { ParticipantNoteActionMenu } from './ParticipantNoteActionMenu';
import { ParticipantNoteEditModal } from './ParticipantNoteEditModal';
import { ParticipantNoteEditorViewOnly } from './ParticipantNoteEditorViewOnly';

interface Props {
  participantNote: ParticipantNote;
  isDisabled?: boolean;
}

export const ParticipantNoteCard = (props: Props) => {
  const { participantNote, isDisabled } = props;

  return (
    <ChakraV3.Card.Root w='full'>
      <ChakraV3.Card.Header py={4}>
        <ChakraV3.HStack fontSize='sm' gap={4} w='full'>
          <UserDescription
            name={participantNote.user?.name ?? COMPANY_NAME}
            secondary={participantNote.user?.email ?? ADMIN_EMAIL}
            picture={participantNote?.user?.picture}
          />

          <ManageParticipantNoteLabelsControl
            participantNote={participantNote}
            isDisabled={isDisabled}
          />
          <ChakraV3.Spacer />
          <ChakraV3.HStack flexShrink={0} gap={4}>
            <FancyDate date={participantNote.createdAt} showHumanized={false} />
            <ParticipantNoteActionMenu
              participantNote={participantNote}
              size='sm'
              disabled={isDisabled}
              variant='outline'
            />
          </ChakraV3.HStack>
        </ChakraV3.HStack>
      </ChakraV3.Card.Header>

      <ChakraV3.Separator />

      <ChakraV3.Card.Body
        as={ScrollArea}
        overflowY='hidden'
        py={0}
        layerStyle='fade'
        onClick={() =>
          showModal(ParticipantNoteEditModal, {
            participantId: participantNote.participantId,
            participantNoteId: participantNote.id,
            isDisabled,
          })
        }
        cursor='pointer'
        data-pw={`participantNoteCard-${participantNote.id}`}
      >
        <ChakraV3.Stack h='xs'>
          <ParticipantNoteEditorViewOnly value={participantNote.value} />
        </ChakraV3.Stack>
      </ChakraV3.Card.Body>
      <ChakraV3.Separator />
    </ChakraV3.Card.Root>
  );
};
